import type { SetShowToastPayload } from '../slices/ui-slice';
import uiSlice from '../slices/ui-slice';

export const getShowToastAction = (payload: SetShowToastPayload) =>
  uiSlice.actions.showToast(payload);

export const getHideToastAction = () => uiSlice.actions.hideToast(null);
